import { TicketPromotional } from '@core/mappers/country/dtos/IDirectusConfigDto';
import { MaintenanceType } from './enums';
import { SuperBonusConfig, TaxBase, TaxBracket, TaxMode } from '@superbet-group/betting.lib.payments';

export enum HandlingFeeMethod {
  TaxOnNet = 2,
  TaxOnGross = 3,
}

export enum WinTaxMethod {
  OneStep = 1,
  MultiStep = 2,
}

interface Deposit {
  onlineDefault: number;
  onlineMin: number;
  onlineMax: number;
  tax: string;
}

interface Withdrawal {
  tax: string;
  bankTransferMin: number;
  bankTransferMax: number;
  onlineMin: number;
  onlineMax: number;
  shopMin: number;
  shopMax: number;
  instantMin: number;
  instantMax: number;
}

interface ApplicationStatus {
  maintainedParts: Record<MaintenanceType, boolean>;
  maintenanceFrameUrl: string;
  /**
   * Used for application level notification.
   * Example: user plays lottery, in the mean time sport goes in maintenance.
   * We display service message to inform users about the change.
   */
  serviceMessage: string;
}

export interface TaxLimit {
  lowerBound: number;
  percentage: number;
}

interface Tickets {
  paymentHost: string;
  paymentHostSocket: string;
  cacheV3: string;
  socketPath?: string;
  allowancesUrl?: string;
  virtualTournamentsEndpoint?: string;
}

interface Offer {
  hostServer: string;
  visualisation: {
    sevenScoutCheckCoverageUrl: string;
    sevenScoutCheckCoverageUUID: string;
    sevenScoutSupportedSports: number[];
    sevenScoutVisualizationActive: boolean;
    sevenScoutUrl: string;
  };
  hostServerAllValues: string[];
  socketIoAllValues: string[];
}

interface Auth {
  host: string;
}

interface User {
  host: string;
}

interface Bonus {
  host: string;
}

interface Country {
  host: string;
}

interface DocumentUpload {
  fileSize: number;
  fileSizeHumanReadable: string;
}

interface Superbets {
  superbetsRange: [number, number] | null;
}

interface BetSlip {
  stakeMax: number;
  stakeMin: number;
  minStakePerCombination: number;
  maxWin: number;
  maxSelectedNumbers: number;
  offlineTax: number;
  onlineTax: number;
  winTaxBounds: TaxLimit[];
  minOddBonus: number;
  minOddPariulSansa?: number;
  minSelectionPariulSansa?: number;
  maxBonusPercent: number;
  handlingFeeMethod: HandlingFeeMethod;
  handlingFeeInverse: boolean;
  taxPerSystem: boolean;
  taxMode: TaxMode;
  taxBase: TaxBase;
  taxBrackets: TaxBracket[];
  areSuperBonusSpecialsValidOnline: boolean;
  bonusConfig: SuperBonusConfig;
}

interface LottoBetSlip {
  stakeMax: number;
  stakeMin: number;
  maxWin: number;
  maxSelectedNumbers: number;
  offlineTax: number;
  onlineTax: number;
  handlingFeeInverse: boolean;
  taxMode: TaxMode;
  taxBase: TaxBase;
  taxBrackets: TaxBracket[];
}

interface VirtualConfig {
  baseUrl: String;
}

interface TestingAccounts {
  accounts: Record<number, boolean>;
  virtualGamesAccounts: Record<number, boolean>;
}

interface CashoutConfig {
  cashoutBackend: string;
  cashoutFrontendEnabled: boolean;
}

interface Retail {
  script?: string;
}

interface SuperSpin {
  superSpinTermsUrl?: string;
  superSpinUrl?: string;
}

interface Games {
  skywindUrl?: string;
  skywindFeatures?: string;
  gamesPersonalisationEnabled: boolean;
  liveDealerEnabled: boolean;
  virtualGamesUrl: string;
}

interface AntiFraud {
  host: string;
}

export default interface ServerConfig {
  withdrawal: Withdrawal;
  deposit: Deposit;
  applicationStatus: ApplicationStatus;
  betSlip: BetSlip;
  lottoBetSlip: LottoBetSlip;
  tickets: Tickets;
  offer: Offer;
  auth: Auth;
  user: User;
  bonus: Bonus;
  antiFraud: AntiFraud;
  country: Country;
  newsHost: string;
  general: GeneralConfig;
  virtual: VirtualConfig;
  testingAccounts: TestingAccounts;
  cashout: CashoutConfig;
  documentUpload: DocumentUpload;
  superbets: Superbets;
  retail: Retail;
  superSpin: SuperSpin;
  games: Games;
  ticketPromotional: TicketPromotional;
}

export interface GeneralConfig {
  timeZoneOffset: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/country/ServerConfig.ts